import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-facility-filter',
  templateUrl: './facility-filter.component.html',
  styleUrls: ['./facility-filter.component.scss']
})
export class FacilityFilterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  @Output() CloseAddfilter = new EventEmitter<boolean>()

  Closefilter(message) {
    this.CloseAddfilter.emit(message);   
  }

}
